// account screens' English text (D146). Keys start with "account.".
export const account = {
  'account.nav.label': 'Family apps',
  'account.nav.chats': 'Chats',
  'account.nav.documents': 'Documents',
  'account.nav.links': 'Links',
  'account.nav.lists': 'Lists',
  'account.header.closeSearch': 'Close search',
  'account.header.searchChats': 'Search chats',
  'account.header.calls': 'Calls',
  'account.header.starred': 'Starred messages',
  'account.header.yourAccount': 'Your account',
  'account.menu.families': 'My Families',
  'account.menu.invitations': 'Invitations',
  'account.menu.mentions': 'Mentions',
  'account.menu.profile': 'Profile',
  'account.menu.settings': 'Settings',
  // Shape Twinden (M55, D198)
  'account.menu.ideas': 'Shape Twinden',
  'account.menu.darkMode': 'Dark mode',
  'account.menu.lightMode': 'Light mode',
  'account.menu.logOut': 'Log out',
  'account.passkeyHere.done': 'This device can now sign in by itself',
  'account.passkeyHere.failed': 'Couldn’t create a passkey',
  'account.passkeyHere.title': 'Sign in faster on this device?',
  'account.passkeyHere.body':
    'You signed in with a passkey from another device. Create one here too and next time this device signs in by itself. Your other device keeps its passkey.',
  'account.passkeyHere.create': 'Create a passkey',
  'account.passkeyHere.notNow': 'Not now',
  'account.avatar.wrongType': 'Please upload a JPEG, PNG, GIF, or WebP image',
  'account.avatar.tooBig': 'Image must be less than 25 MB',
  'account.avatar.readFailed': 'Failed to read file',
  'account.avatar.upload': 'Upload',
  'account.avatar.remove': 'Remove image',
  'account.switcher.label': 'Switch family, current: {name}',
  'account.switcher.membersOne': '1 member',
  'account.switcher.membersOther': '{count} members',
  'account.switcher.pendingInvites': 'Pending invites',
  'account.noFamily.title': 'Select a family first',
  'account.noFamily.body':
    'Family apps are scoped to the family in the switcher at the top.',
  'account.relation.title': 'What do you call {name}?',
  'account.relation.hint': 'Shown instead of their name, only to you.',
  'account.relation.placeholder': 'Or type a name',
  'account.relation.label': 'What you call them',
  'account.relation.useName': 'Use their name',
  'account.settings.never': 'never',
  'account.settings.testSent': 'Test notification sent',
  'account.settings.title': 'Settings',
  'account.settings.subtitle': 'Notifications, sounds and this device',
  'account.settings.account': 'Account',
  'account.settings.appearance': 'Appearance',
  'account.settings.darkModeHint': 'Easier on the eyes at night',
  // Festival mode (D312): a device setting.
  'account.settings.festivalTouches': 'Festival touches',
  'account.settings.festivalTouchesHint':
    'A small diya, kite or crescent on the home screen on festival days. Only on this device.',
  'account.settings.notifications': 'Notifications',
  'account.settings.notificationsDescription':
    'Messages, calls and family updates, even when Twinden is closed.',
  'account.settings.pushNotConfigured':
    'Notifications aren’t set up on this server yet (it needs VAPID keys).',
  // D307: the heading over the reason and its fix.
  'account.settings.pushUnsupported': 'Notifications can’t be turned on here',
  'account.settings.pushOn': 'Notifications are on',
  'account.settings.pushOff': 'Notifications are off',
  // D185
  'account.settings.pushInstall': 'Install Twinden to get notifications',
  'account.settings.pushInstallHint':
    'On iPhone and iPad, notifications only work in the Home Screen app.',
  'account.settings.pushInstallHow': 'How',
  'account.settings.noDevices': 'No devices yet',
  'account.settings.devicesOne': '1 device',
  'account.settings.devicesOther': '{count} devices',
  'account.settings.turnOff': 'Turn off',
  'account.settings.turnOn': 'Turn on',
  'account.settings.messages': 'Messages',
  'account.settings.messagesLabel': 'Message notifications',
  'account.settings.callsHint': 'Incoming and missed calls',
  'account.settings.callsLabel': 'Call notifications',
  'account.header.gatherings': 'Gatherings',
  'account.settings.gatheringsHint': 'Reminders and “Come now” rings',
  'account.settings.gatheringsLabel': 'Gathering notifications',
  'account.settings.familyUpdates': 'Family updates',
  'account.settings.familyUpdatesHint':
    'Documents, links, lists, things assigned to you',
  'account.settings.familyUpdatesLabel': 'Family update notifications',
  'account.settings.muteFamily': 'Mute {name}',
  'account.settings.muteFamilyHint': 'No notifications from this family',
  'account.settings.pushDevices': 'Devices with notifications',
  'account.settings.unknownDevice': 'Unknown device',
  'account.settings.since': 'since {date}',
  'account.settings.sendTest': 'Send a test notification',
  'account.settings.indianDates': 'Indian dates and times',
  'account.settings.indianDatesOn': 'Like {sample}',
  'account.settings.indianDatesOff':
    'Off: your device’s own style, like {sample}',
  'account.settings.photos': 'Photos',
  // Aashirwad (D280).
  'account.settings.blessings': 'Blessings',
  'account.settings.blessingsDescription':
    'Bless anyone’s message in one tap. It goes as a reply, sealed like any message.',
  'account.settings.blessingButton': 'Blessing button on messages',
  'account.settings.blessingButtonHint':
    'A 🙏 beside messages from others. Otherwise, Bless is in each message’s menu.',
  'account.settings.blessingWords': 'Your blessing',
  'account.settings.blessingWordsHint':
    'Kept on this device. Leave it empty for “Jeete raho 🙏”.',
  'account.settings.photosDescription':
    'How photos you send leave this device.',
  'account.settings.originalQuality': 'Send photos in original quality',
  'account.settings.originalOn': 'Full size: slower to send and to download.',
  'account.settings.originalOff':
    'Off: photos are sent at up to 1600 pixels, faster and smaller. Send a file to keep its full size.',
  'account.settings.sounds': 'Sounds & vibration',
  'account.settings.soundsDescription':
    'While Twinden is open on this device. Muted chats and families stay quiet.',
  'account.settings.messageSound': 'New message sound',
  'account.settings.ringtone': 'Ringtone for calls',
  'account.settings.vibrate': 'Vibrate',
  'account.settings.cantVibrate':
    'This browser can’t vibrate (iPhone and computers)',
  'account.settings.testSound': 'Test message sound',
  'account.settings.testRingtone': 'Test ringtone',
  'account.settings.closedSounds':
    'When Twinden is closed, notifications use your phone’s own sound and vibration; change those in your phone’s settings.',
  'account.settings.install': 'Install Twinden',
  'account.settings.installDescription':
    'Put Twinden on your home screen. On iPhone, notifications only work once it’s installed.',
  'account.settings.installGuide': 'Step-by-step guide for this device',
  'account.settings.installIphone':
    'iPhone or iPad: tap Share, then “Add to Home Screen”.',
  'account.settings.installAppleTab':
    'The Home Screen app is a separate device. Open it while this tab is still open, so this tab can hand it your messages’ keys.',
  'account.settings.installDesktop':
    'Chrome or Edge on a computer: use the install icon in the address bar.',
  'account.role.root': 'Root',
  'account.role.admin': 'Admin',
  'account.role.member': 'Member',
  'account.profile.birthdaySaveFailed': 'Could not save your birthday',
  'account.profile.updated': 'Profile updated',
  'account.profile.updateFailed': 'Could not update profile',
  'account.profile.unknownError': 'Unknown error',
  'account.profile.renameFailed': 'Could not rename the device',
  'account.profile.deviceRemoved': 'Device removed',
  'account.profile.removeFailed': 'Could not remove the device',
  'account.profile.linkFailed': 'Couldn’t make a link',
  'account.profile.linkCopied': 'Link copied',
  'account.profile.copyFailed': 'Couldn’t copy the link',
  'account.profile.pictureUpdated': 'Picture updated',
  'account.profile.pictureRemoved': 'Picture removed',
  'account.profile.passkeyCreated': 'Passkey created on this device',
  'account.profile.anotherPasskeyTitle': 'This device already has a passkey',
  'account.profile.anotherPasskeyBody':
    'Make another one to keep it somewhere else, like a password manager such as NordPass: choose it when your phone asks where to save. You can then remove the old one below.',
  'account.profile.anotherPasskeyCreate': 'Make another passkey',
  'account.profile.yourName': 'Your name',
  'account.profile.saveName': 'Save name',
  'account.profile.changeName': 'Change name',
  'account.profile.birthday': 'Birthday',
  'account.profile.birthdayDescription':
    'Day and month only, no year. Your family sees it so they can wish you.',
  'account.profile.month': 'Month',
  'account.profile.day': 'Day',
  'account.profile.noSuchDay': '{month} doesn’t have a day {day}.',
  'account.profile.notAdded': 'Not added',
  'account.profile.removeBirthday': 'Remove your birthday',
  'account.profile.changeBirthday': 'Change your birthday',
  'account.profile.addBirthday': 'Add your birthday',
  'account.profile.change': 'Change',
  'account.profile.add': 'Add',
  'account.profile.families': 'My families',
  'account.profile.familiesDescription':
    'You can be in several families and switch between them at the top.',
  'account.profile.noFamilies': 'You’re not in a family yet.',
  'account.profile.manage': 'Manage',
  'account.profile.devices': 'My devices',
  'account.profile.devicesDescription':
    'Each phone or computer signs in with its own passkey. Add a new one here; remove one you no longer use (your last one can’t be removed).',
  'account.profile.noDevices': 'No devices found.',
  'account.profile.unnamedDevice': 'Unnamed device',
  'account.profile.added': 'Added {added}',
  'account.profile.addedUsed': 'Added {added} · last used {used}',
  'account.profile.device': 'device',
  'account.profile.renameNamed': 'Rename {name}',
  'account.profile.removeNamed': 'Remove {name}',
  'account.profile.confirmItsYou': 'Confirm it’s you…',
  'account.profile.addDevice': 'Add a device',
  'account.profile.waitingDevice': 'Waiting for your device…',
  'account.profile.passkeyHere': 'Add a passkey on this device',
  'account.profile.keysSentOne': 'Sent keys for 1 chat to your new device',
  'account.profile.keysSentOther':
    'Sent keys for {count} chats to your new device',
  'account.profile.deviceReady': 'Your new device is ready',
  'account.profile.deviceReadyHint':
    'Your messages open there now. You can close this.',
  'account.profile.qrAlt': 'QR code that adds a device to your account',
  'account.profile.linkHint':
    'On the new device, scan this with the camera or open the link there. It works once, for the next',
  'account.profile.linkHintEnd': '.',
  'account.profile.copyLink': 'Copy link',
  'account.profile.waitingNewDevice':
    'Waiting for your new device. Keep this open: it hands the new device your messages’ keys.',
  'account.profile.linkExpired':
    'This link has expired. Make a new one when the device is ready.',
  'account.profile.newLink': 'Make a new link',
  'account.profile.cancelLink': 'Cancel link',
  'account.profile.renameDevice': 'Rename device',
  'account.profile.deviceName': 'Device name',
  'account.profile.removeTitle': 'Remove “{name}”?',
  'account.profile.thisDevice': 'this device',
  'account.profile.removeBody':
    'Its passkey stops working, so it can’t sign in any more. You can add it again with a new link.',
  'account.profile.removeDevice': 'Remove device',
  'account.profile.keepIt': 'Keep it',
  'account.families.left': 'Left {name}',
  'account.families.leaveFailed': 'Could not leave family',
  'account.families.subtitle':
    'Each family is its own space, with its own people, chats and things.',
  'account.families.invitedOne': 'You’re invited to a family',
  'account.families.invitedOther': 'You’re invited to {count} families',
  'account.families.review': 'Review',
  'account.families.emptyTitle': 'You’re not in a family yet',
  'account.families.emptyBody':
    'Someone who runs a family on Twinden can invite you. Invitations show up here.',
  'account.families.checkInvites': 'Check invitations',
  'account.families.open': 'Open {name}',
  'account.families.actions': 'Family actions',
  'account.families.openChats': 'Open chats',
  'account.families.manage': 'Manage family',
  'account.families.leave': 'Leave family',
  'account.families.leaveTitle': 'Leave {name}?',
  'account.families.thisFamily': 'this family',
  'account.families.leaveBody':
    'You’ll stop seeing its chats, documents, links and lists. An admin can invite you back with a new QR code.',
  'account.families.stay': 'Stay',
  'account.admin.justNow': 'just now',
  'account.admin.minutesAgo': '{count}m ago',
  'account.admin.hoursAgo': '{count}h ago',
  'account.admin.daysAgo': '{count}d ago',
  'account.admin.iconUpdated': 'Family icon updated',
  'account.admin.iconRemoved': 'Family icon removed',
  'account.admin.iconFailed': 'Could not update the family icon',
  'account.admin.createInviteFailed': 'Could not create the invitation',
  'account.admin.roleChanged': 'Role changed to {role}',
  'account.admin.roleFailed': 'Could not change the role',
  'account.admin.removeConfirm': 'Remove {name} from {family}?',
  'account.admin.removed': '{name} removed',
  'account.admin.removeFailed': 'Could not remove the member',
  'account.admin.copyFailed': 'Copy failed — select the link manually',
  'account.admin.notFound': 'Family not found',
  'account.admin.backToFamilies': 'Back to families',
  'account.admin.tokenEnroll': '@{handle} ({name}) as {role}',
  // A link made since D348 holds no handle.
  'account.admin.tokenEnrollName': '{name} as {role}',
  // Add someone you know (D350)
  'account.knows.title': 'Add someone you know',
  'account.knows.hint':
    'People from your other families. They get an invitation and join only if they say yes.',
  'account.knows.search': 'Search by name or @handle',
  'account.knows.empty': 'Nobody from your other families to invite here.',
  'account.knows.noMatch': 'Nobody matches “{query}”.',
  'account.knows.pick': 'Invite {name}',
  'account.knows.inviting': 'Inviting {name}',
  'account.knows.role': 'Role',
  'account.knows.send': 'Send invitation',
  'account.knows.cancel': 'Choose someone else',
  'account.knows.sent': 'Invitation sent to {name}',
  'account.knows.sentHint': 'They join when they tap Join.',
  'account.knows.failed': 'Could not send the invitation',
  'account.knows.loadFailed': 'Could not load the people you know',
  'account.invites.invitedYou': '{name} invited you to join the {family}',
  // Family handles (M59, D215–D217)
  'account.familyHandle.edit': 'Edit name and handle',
  'account.familyHandle.title': 'Name and handle',
  'account.familyHandle.label': 'Family handle',
  'account.familyHandle.hint':
    'Tells your family apart from others with the same name.',
  'account.familyHandle.changesLeft':
    'You can change it 3 times in 30 days ({count} left).',
  'account.familyHandle.noneLeft':
    'Changed 3 times in 30 days. You can change it again later.',
  'account.familyHandle.rootsOnly': 'Only roots can change the handle.',
  'account.familyHandle.checking': 'Checking…',
  'account.familyHandle.free': '@{handle} is free',
  'account.familyHandle.taken': '@{handle} is taken',
  'account.familyHandle.reserved': '@{handle} is reserved',
  'account.familyHandle.invalid':
    'Use 3–32 small letters, numbers or single dashes, not at the start or end',
  'account.familyHandle.links':
    'Family links keep working. The old handle isn’t kept for you.',
  'account.familyHandle.saved': 'Saved',
  'account.familyHandle.saveFailed': 'Could not save',
  'account.familyHandle.limit': 'You can change the handle again on {date}.',
  'account.admin.renamed': 'Family renamed',
  'account.admin.renameFailed': 'Could not rename the family',
  'account.admin.rename': 'Rename family',
  'account.admin.subtitleOne': 'You’re {role} here · {count} member',
  'account.admin.subtitleOther': 'You’re {role} here · {count} members',
  'account.admin.members': 'Members',
  'account.admin.invite': 'Invite',
  'account.admin.pending': 'Pending',
  'account.admin.activity': 'Activity',
  'account.admin.youBadge': 'you',
  'account.admin.joined': 'joined {time}',
  'account.admin.memberActions': 'Member actions',
  'account.admin.makeRoot': 'Make root',
  'account.admin.makeAdmin': 'Make admin',
  'account.admin.makeMember': 'Make member',
  'account.admin.removeFromFamily': 'Remove from family',
  'account.admin.inviteNew': 'Invite someone new',
  'account.admin.inviteNewHint':
    'Creates a one-time QR code / link. Someone new picks a handle and makes a passkey on their own device; someone already on Twinden joins with their own account.',
  'account.admin.handle': 'Handle',
  'account.admin.displayName': 'Display name',
  'account.admin.role': 'Role',
  'account.admin.createInvite': 'Create invitation',
  'account.admin.pendingLinks': 'Pending enrollment links',
  'account.admin.noPendingLinks': 'No pending links.',
  'account.admin.createdExpires': 'created {ago} · expires {date}',
  'account.admin.regenerateFailed': 'Could not regenerate',
  'account.admin.newLink': 'New link',
  'account.admin.revokeFailed': 'Could not revoke',
  'account.admin.revoke': 'Revoke',
  'account.admin.pendingInvites': 'Pending in-app invitations',
  'account.admin.noPendingInvites': 'Nobody is waiting to accept.',
  'account.admin.handleAs': '@{handle} as {role}',
  'account.admin.invitedExpires': 'invited {ago} · expires {date}',
  'account.admin.waiting': 'waiting',
  'account.admin.noActivity': 'No activity recorded yet.',
  'account.admin.systemRoot': 'System root',
  'account.admin.familyName': 'Family name',
  'account.admin.inviteLink': 'Invitation link',
  'account.admin.qrAlt': 'Invitation QR code',
  'account.admin.qrEnroll':
    'Have {name} scan this on the device they will use. It works once and expires {date}.',
  'account.invites.joined': 'Joined the family',
  'account.invites.joinedHint': 'You can now open its groups and chats.',
  'account.invites.acceptFailed': 'Could not accept',
  'account.invites.declined': 'Invitation declined',
  'account.invites.declineFailed': 'Could not decline',
  'account.invites.subtitle':
    'Families that want you to join. You keep the same account and handle.',
  'account.invites.checkAgain': 'Check again',
  'account.invites.emptyTitle': 'No invitations',
  'account.invites.emptyBody':
    'When a family invites you, it shows up here and as a dot on your photo.',
  'account.invites.details': 'As {role} · from @{handle} · until {date}',
  'account.invites.join': 'Join',
  'account.invites.noThanks': 'Not now',
  'account.login.unknownCredential':
    'This passkey is not registered on this server.',
  'account.login.sessionExpired':
    'The login session expired. Please try again.',
  'account.login.verificationFailed':
    'Passkey verification failed. Please try again.',
  'account.login.compromised':
    'This passkey was revoked for security reasons. Sign in with another passkey, or add this device from one you’re signed in on.',
  'account.login.cancelled':
    'The passkey prompt was cancelled. Tap the button to try again.',
  'account.login.tryAgain': 'Something went wrong. Please try again.',
  'account.login.subtitle':
    'Your family’s own place to talk, share and keep things.',
  'account.login.noAccount':
    'No account yet? Ask someone in your family for a join QR code, or {request}.',
  'account.login.requestInvite': 'request an invitation',
  'account.login.help': 'Help',
  'account.login.whatIs': 'What is Twinden?',
  'account.login.installFirst': 'Install Twinden first',
  'account.login.installFirstBody':
    'Tap {share}, then {add}, and sign in from the new icon. You’ll get notifications, and this phone stays one device for your messages instead of two.',
  'account.login.showMe': 'Show me how',
  'account.login.continueSafari': 'Continue in Safari',
  'account.login.getAppBody':
    'Get Twinden from the App Store and sign in there. You’ll get notifications, and this phone stays one device for your messages instead of two.',
  'account.login.signIn': 'Sign in with a passkey',
  'account.login.unsupported':
    'This browser can’t use passkeys. Use a recent Chrome, Safari, Firefox or Edge.',
  'account.login.noPassword':
    'Your face, fingerprint or screen lock signs you in. There’s no password to forget.',
  'account.join.tokenNotFound':
    'This enrollment link is invalid. Ask your family root for a new one.',
  'account.join.tokenConsumed':
    'This link was already used. If it made your account, just sign in with your passkey.',
  'account.join.addDeviceSelfOnly':
    'Only you can add a device to your account: on a device you’re signed in on, go to Profile → My devices → Add a device.',
  'account.join.tokenRevoked':
    'This enrollment link was revoked. Ask your family root for a new one.',
  'account.join.tokenExpired':
    'This enrollment link expired. Ask your family root for a new one.',
  'account.join.handleTaken':
    'That handle was just taken. Ask your family root to re-issue your enrollment link.',
  'account.join.alreadyRegistered':
    'This device already has a passkey. Just sign in instead.',
  'account.join.sessionExpired':
    'The registration session expired. Please try again.',
  'account.join.wrongOrigin':
    'This link must be opened on the same address the server is configured for (check RP_ID/ORIGIN in .env).',
  'account.join.alreadyHasPasskey':
    'This device already has a passkey for this account. Just sign in instead.',
  'account.join.errorDetail': 'Something went wrong: {detail}',
  'account.join.invalid': 'This enrollment link is invalid.',
  'account.join.joining': 'Joining…',
  'account.join.unsupportedTitle': 'This browser can’t join',
  'account.join.unsupportedBody':
    'It can’t create passkeys. Open this link on a recent phone or computer: iOS 16 or later, Android 9 or later, or a current Chrome, Safari, Firefox or Edge.',
  'account.join.errorTitle': 'Can’t join with this link',
  'account.join.almostTitle': 'Almost there',
  'account.join.almostBody':
    'Follow your device’s prompt to create your passkey.',
  'account.join.addDevice': 'Add this device',
  'account.join.welcome': 'Welcome, {name}',
  'account.join.addDeviceBody':
    'This device will sign in as @{handle} in {family}.',
  'account.join.joiningBody': 'You’re joining {family} as @{handle}.',
  // A personal link that holds no handle (D348): they pick one here.
  'account.join.joiningBodyPick': 'You’re joining {family}. Pick your handle.',
  'account.join.addDeviceFooter': 'This creates a passkey on this device.',
  'account.join.joiningFooter':
    'One tap creates your account. No password, ever.',
  'account.join.nameDevice': 'Name this device (optional)',
  'account.join.nameDevicePlaceholder': 'e.g. My iPhone',
  'account.join.createPasskey': 'Create my passkey',
  'account.install.notifications':
    'Turn on notifications: tap your picture at the top right, then {path}, and {allow}.',
  'account.install.openSettings': 'Open Settings',
  'account.install.subtitle':
    'Put Twinden on your home screen like an app, then turn on notifications.',
  'account.install.back': 'Back to Twinden',
  // The store app first, when its link is set (D346)
  'account.install.getApp': 'Get the Twinden app',
  'account.install.getAppBody':
    'Install it from the store, open it and sign in. Notifications and calls work best there.',
  'account.install.orWebApp': 'Or put the web app on your home screen',
  'account.install.installed': 'Twinden is installed on this device.',
  'account.install.safariFirst':
    'Open twinden.com in Safari first: on iPhone, notifications only work for apps added from Safari.',
  'account.install.ios1':
    'In Safari, tap {share}: the square with an arrow, at the bottom of the screen (at the top on iPad).',
  'account.install.ios2': 'Scroll down and tap {add}, then {confirm}.',
  'account.install.fromIcon': 'Twinden from the new icon',
  'account.install.ios3':
    'Open {fromIcon} on your Home Screen, not from Safari.',
  'account.install.ios4': 'Sign in with your passkey.',
  'account.install.ios4Keys':
    'The app is a separate device from this Safari tab: {keepOpen} until the app says “Your messages are unlocked”, so this tab can hand it your messages’ keys.',
  'account.install.keepOpen': 'keep this tab open',
  'account.install.tapInstall': 'Tap {button} and confirm.',
  'account.install.android1':
    'In Chrome, tap the menu {menu} at the top right, then {installApp} (or {addHome}).',
  'account.install.android2': 'Open {fromIcon}. You stay signed in.',
  'account.install.clickInstall': 'Click {button} and confirm.',
  'account.install.installIcon': 'install icon',
  'account.install.computer1':
    'In Chrome or Edge, click the {icon} at the right of the address bar. In Safari on a Mac, {dock}. (Firefox can’t install apps, but notifications still work in the browser.)',
  'account.devices.iphone': 'My iPhone',
  'account.devices.ipad': 'My iPad',
  'account.devices.android': 'My Android device',
  'account.devices.mac': 'My Mac',
  'account.devices.windows': 'My Windows PC',
  'account.devices.linux': 'My Linux device',
  'account.devices.alreadyHasPasskey':
    'This device already has a passkey for your account.',
  // Why notifications can't be turned on, and the fix (D307, D308).
  'account.push.why.appleTab':
    'On iPhone and iPad, notifications only work in the Home Screen app. In Safari, tap Share → “Add to Home Screen”, open Twinden from there, then turn them on.',
  'account.push.why.insecure':
    'Notifications need a secure address. Open Twinden at its https:// address.',
  'account.push.why.privateWindow':
    'Notifications don’t work in a private window. Open Twinden in a normal window to turn them on.',
  'account.push.why.noServiceWorker':
    'This browser can’t run Twinden in the background here, so it can’t show notifications. In a private window, open a normal one; inside another app (like WhatsApp or Instagram), open the link in your browser; otherwise update your browser.',
  'account.push.why.unsupported':
    'This browser can’t show notifications. Update it, or use Chrome, Edge, Firefox or Safari.',
  'account.push.why.swFailed':
    'Twinden’s background helper couldn’t start in this browser, so notifications can’t be turned on. Reload the page; if it keeps happening, this browser’s storage for Twinden may be damaged, and another browser such as Chrome or Firefox will work.',
  'account.push.why.blocked':
    'Notifications are blocked for this site. Tap the lock or settings icon next to the address, allow Notifications, then reload. In a private or incognito window they’re always blocked: open a normal one.',
  'account.push.why.brave':
    'Brave keeps web notifications off until you allow them: open brave://settings/privacy, turn on “Use Google services for push messaging”, restart Brave, then try again.',
  'account.push.why.pushService':
    'The browser’s notification service didn’t answer. Check your connection and try again. In a private window, open a normal one.',
  'account.push.why.subscribeFailed':
    'Couldn’t turn on notifications. The browser said: {reason}',
  'account.push.notConfigured':
    'Notifications are not configured on this server',
  'account.push.notGranted': 'Notification permission was not granted',
  'account.push.incomplete': 'The browser returned an incomplete subscription',
  'account.push.enableFailed': 'Could not enable notifications',
  'account.push.disableFailed': 'Could not disable notifications',
  'account.push.saveFailed': 'Could not save notification preferences',
  'account.push.testFailed': 'Could not send a test notification',
  'account.family.loadFamiliesFailed': 'Failed to load families',
  'account.family.loadFailed': 'Failed to load family',
  'account.family.noneSelected': 'No family selected',
  // Fun handles (D147)
  'account.handle.label': 'Handle',
  'account.handle.shuffle': 'Another handle',
  'account.handle.finding': 'Finding a fun handle…',
  'account.handle.failed': 'Could not get a handle. Tap the dice to try again.',
  'account.handle.forever': 'Handles can’t be changed later.',
  'account.handle.needName': 'Type a name first and we’ll make up a handle.',
  'account.handle.takenReplaced': '@{handle} was just taken. Here’s another.',
  // Invite people with the family link (D152)
  'account.invite.title': 'Invite people to the {family}',
  'account.invite.menu': 'Invite people',
  'account.invite.body':
    'Anyone with this link can ask to join. A root or admin lets them in.',
  'account.invite.share': 'Share link',
  'account.invite.copy': 'Copy link',
  'account.invite.copied': 'Link copied',
  'account.invite.shareText': 'Join the {family} on Twinden',
  'account.invite.qrAlt': 'Family link QR code',
  'account.invite.off': 'The family link is turned off.',
  'account.invite.offMember': 'Ask a root or admin to turn it on.',
  'account.invite.reset': 'Reset link',
  'account.invite.turnOff': 'Turn off',
  'account.invite.turnOn': 'Turn on the link',
  'account.invite.resetTitle': 'Reset the family link?',
  'account.invite.resetBody':
    'The old link and QR stop working at once, everywhere. People who already asked stay on the list.',
  'account.invite.offTitle': 'Turn off the family link?',
  'account.invite.offBody':
    'Nobody can ask to join until it’s turned on again. You can turn it on any time.',
  'account.invite.resetDone': 'New family link ready',
  'account.invite.offDone': 'Family link turned off',
  'account.invite.onDone': 'Family link turned on',
  'account.invite.loadFailed': 'Could not load the family link',
  'account.invite.cardBody':
    'One link for the whole family. Share it on WhatsApp or show the QR.',
  'account.invite.open': 'Show family link',
  // People asking to join (D154)
  'account.requests.tab': 'Requests',
  // Family reports (M58, D207)
  'account.reports.tab': 'Reports',
  'account.reports.title': 'Reports',
  'account.reports.description':
    'Members someone in your family reported. Twinden can’t read messages, so a report says who, why and any note, not what was said.',
  'account.reports.none': 'No reports.',
  'account.reports.line': '{reporter} reported {reported}',
  'account.reports.someone': 'Someone',
  'account.reports.aboutMessage': 'About a message',
  'account.reports.handled': 'Handled',
  'account.reports.markHandled': 'Mark handled',
  'account.reports.markUnhandled': 'Mark not handled',
  'account.reports.failed': 'Couldn’t save',
  // Settings: blocked people and about (M58, D208, D209)
  'account.blocked.title': 'Blocked people',
  'account.blocked.description':
    'People you blocked can’t message or call you directly. Family groups are unaffected.',
  'account.blocked.none': 'You haven’t blocked anyone.',
  'account.blocked.unblock': 'Unblock',
  'account.blocked.unblocked': '{name} is unblocked',
  'account.blocked.failed': 'Couldn’t unblock',
  'account.blocked.deleted': 'Deleted account',
  'account.about.title': 'About',
  'account.about.contact': 'Contact Twinden',
  'account.about.contactHint':
    'Questions, problems, or something to tell us: write to us.',
  'account.about.help': 'Help',
  'account.about.privacy': 'Privacy policy',
  'account.about.terms': 'Terms of use',
  'account.about.contactPage': 'Contact',
  'account.requests.title': 'People asking to join',
  'account.requests.empty': 'Nobody is asking to join right now.',
  'account.requests.via': 'via {name}',
  'account.requests.approve': 'Approve',
  'account.requests.decline': 'Decline',
  'account.requests.approveAll': 'Approve all ({count})',
  'account.requests.roleFor': 'Role for {name}',
  'account.requests.approved': '{name} is in',
  'account.requests.declined': 'Declined',
  'account.requests.approvedAll': '{count} people let in',
  'account.requests.declineTitle': 'Decline {name}?',
  'account.requests.declineBody':
    'They won’t be told why, and can ask again after a week.',
  'account.requests.failed': 'Could not do that',
  'account.requests.loadFailed': 'Could not load the requests',
  'account.requests.asking': '{count} asking to join',
  'account.join.linkTitle': 'Join the {family}',
  'account.join.sharedBy': '{name} shared this link with you.',
  'account.join.imNew': 'I’m new to Twinden',
  'account.join.alreadyUse': 'I already use Twinden',
  'account.join.chooseFooter':
    'Already on Twinden? Sign in, so you don’t make a second account.',
  // Join links open in the app once it's installed (D346)
  'account.join.getApp': 'Prefer the app?',
  'account.join.getAppBody':
    'Install Twinden, then open this link again: it opens in the app.',
  'account.join.continueAs': 'Continue as {name}',
  'account.join.notYou': 'Not you?',
  'account.join.signOut': 'Sign out',
  'account.join.yourName': 'Your name',
  'account.join.yourNamePlaceholder': 'e.g. Ravi Sharma',
  'account.join.youllBe': 'You’ll be',
  'account.join.note': 'A note to the family (optional)',
  'account.join.notePlaceholder': 'e.g. Sunil’s daughter',
  'account.join.askToJoin': 'Ask to join',
  'account.join.newFooter':
    'The family sees your name, handle and note, and lets you in.',
  'account.join.deadLink':
    'This link doesn’t work any more — ask the family for a new one',
  'account.join.notAddedThisTime': 'The {family} didn’t add you this time.',
  'account.join.tooMany':
    'Lots of people are waiting to join the {family}. Try again later.',
  'account.join.waitingTitle': 'Asking the {family} to let you in',
  'account.join.waitingBody':
    'Someone in the family will let you in. You’ll see the family here as soon as they do.',
  'account.join.openTwinden': 'Open Twinden',
  'account.join.personalTitle': 'Join the {family}?',
  'account.join.personalBody': 'You’ll join with your account, @{handle}.',
  'account.join.join': 'Join',
  'account.join.alreadyIn': 'You’re already in the {family}',
  'account.waiting.cancel': 'Cancel request',
  'account.waiting.cancelled': 'Request cancelled',
  'account.waiting.noneTitle': 'You’re not in a family yet',
  'account.waiting.noneBody':
    'Ask someone in your family for their family link, or for a personal link, and open it on this device.',
  'account.waiting.youreIn': 'You’re in the {family}',
  'account.waiting.loadFailed': 'Could not load your requests',
  'account.scan.heading': 'Scan with Twinden on your phone',
  'account.scan.choose': 'Choose {number} on your phone',
  'account.scan.steps': 'Profile → My devices → Scan to sign in',
  'account.scan.qrAlt': 'QR code for signing in with your phone',
  'account.scan.newCode': 'Show a new code',
  'account.scan.stopped': 'This code has run out.',
  'account.scan.failed': 'Could not make a code. Check your connection.',
  'account.scan.limited':
    'Too many codes from this network. Try again in a few minutes.',
  'account.scan.onComputer': 'Signing in on a computer?',
  'account.scan.hide': 'Hide the code',
  'account.scanApprove.title': 'Sign in on this computer?',
  'account.scanApprove.heading': 'Sign in on a computer',
  'account.scanApprove.signInFirst':
    'Sign in on this phone first, then you can sign in the computer.',
  'account.scanApprove.signIn': 'Sign in with your passkey',
  'account.scanApprove.says': 'The computer says it is',
  'account.scanApprove.saysNothing': 'The computer didn’t say what it is.',
  'account.scanApprove.kind.iphone': 'An iPhone',
  'account.scanApprove.kind.ipad': 'An iPad',
  'account.scanApprove.kind.android': 'An Android device',
  'account.scanApprove.kind.mac': 'A Mac',
  'account.scanApprove.kind.windows': 'A Windows computer',
  'account.scanApprove.kind.linux': 'A Linux computer',
  'account.scanApprove.madeAt': 'Code shown at {time}',
  'account.scanApprove.warning':
    'Only scan a code shown on a screen in front of you. Anyone you send this to can read your messages.',
  'account.scanApprove.whichNumber': 'Which number is on the computer?',
  'account.scanApprove.numberHint':
    'Tap it, then confirm it’s you with your passkey.',
  'account.scanApprove.cancel': 'Cancel',
  'account.scanApprove.wrongNumber':
    'That wasn’t the number — the computer will show a new code.',
  'account.scanApprove.expired':
    'This code has run out. Scan the new one on the computer.',
  'account.scanApprove.cancelled':
    'Cancelled. The computer will show a new code.',
  'account.scanApprove.loadFailed':
    'Could not open this code. Check your connection.',
  'account.scanApprove.sending': 'Sending your messages to the computer…',
  'account.scanApprove.sendingHint':
    'Keep this screen open until the computer is ready.',
  'account.scanApprove.done': 'Done',
  'account.scanApprove.doneHint':
    'The computer is signed in and has your messages.',
  'account.scanApprove.doneNoKeys':
    'The computer is signed in. Your messages will reach it from a device that has them — open Twinden on your phone’s Home Screen app.',
  'account.scanApprove.doneSoon':
    'Your messages will reach the computer in a moment.',
  'account.scanApprove.openOnPhone': 'Open this on your phone',
  'account.scanApprove.openOnPhoneBody':
    'Scan the code on the computer with the phone you use Twinden on.',
  'account.scanApprove.openTwinden': 'Open Twinden',
  'account.scanner.title': 'Scan to sign in',
  'account.scanner.hint': 'Point the camera at the code on the computer.',
  'account.scanner.notCode': 'That isn’t a Twinden sign-in code',
  'account.scanner.denied':
    'Twinden can’t use the camera. Allow the camera for this site in your browser settings, then try again.',
  'account.scanner.noCamera': 'Could not start the camera on this device.',
  'account.scanner.close': 'Close',
  'account.profile.scanToSignIn': 'Scan to sign in',
  // Delete my account (M51, D172).
  'account.delete.row': 'Delete my account',
  'account.delete.rowHint': 'Removes your account for good',
  'account.delete.button': 'Delete',
  'account.delete.title': 'Delete your account?',
  'account.delete.intro': 'It happens at once and can’t be undone.',
  'account.delete.messages':
    'Your messages stay in your families’ chats, shown as “Deleted account”. Your name, picture and birthday are removed.',
  'account.delete.devices':
    'Your passkeys, devices, sessions and notifications are removed, and you leave every family and chat.',
  'account.delete.roots':
    'Where you’re the only root, the longest-standing admin (or else member) becomes root. A family with only you in it is deleted with everything in it.',
  'account.delete.handle':
    'Your handle @{handle} is never given to anyone else.',
  'account.delete.continue': 'Confirm it’s you',
  'account.delete.confirmTitle': 'Delete your account for good?',
  'account.delete.confirmBody':
    'Last step. When you tap Delete, your account is gone and this device signs out.',
  'account.delete.confirm': 'Delete my account',
  'account.delete.keep': 'Keep my account',
  'account.delete.done': 'Your account was deleted',
  // Deleted accounts (M51).
  'account.deletedAccount': 'Deleted account',
  'account.family.nowRoot': 'You’re now a root of {name}',
  'account.family.nowRootBody':
    'Its only root deleted their account, so you look after the family now.',
  // Delete family, and download first (M54, D187–D194).
  'account.dangerZone.title': 'Danger zone',
  'account.dangerZone.body':
    'Take a copy of the family’s photos and documents, or delete the family for everyone.',
  'account.dangerZone.bodyAdmin':
    'Take a copy of the family’s photos and documents to keep.',
  'account.exportFamily.row': 'Download photos and documents',
  'account.exportFamily.rowHint':
    'From the chats you’re in, with Documents, Links and Lists, in one zip',
  'account.exportFamily.button': 'Download',
  'account.exportFamily.title': 'Download photos and documents',
  'account.exportFamily.body':
    'One zip with the photos, videos, voice notes and files from the chats you’re in, each chat’s messages as text, and the Documents, Links and Lists of {family}.',
  'account.exportFamily.private':
    'It’s put together on this device, which holds the keys. The server can’t read any of it.',
  'account.exportFamily.phoneNote':
    'With many photos this can take a while, especially on a phone. Keep Twinden open until it’s done.',
  'account.exportFamily.start': 'Start download',
  'account.exportFamily.scanning':
    'Looking through the chats… {done} of {total}',
  'account.exportFamily.progress': '{done} of {total} files',
  'account.exportFamily.cancel': 'Cancel download',
  'account.exportFamily.doneTitle': 'Downloaded',
  'account.exportFamily.doneBody': '{count} files saved in “{file}”.',
  'account.exportFamily.skipped':
    '{count} couldn’t be included. The zip lists them in not-included.txt.',
  'account.exportFamily.failed': 'The download stopped. Please try again.',
  'account.deleteFamily.row': 'Delete family',
  'account.deleteFamily.rowHint':
    'Removes the family and everything in it, for everyone',
  'account.deleteFamily.button': 'Delete',
  'account.deleteFamily.title': 'Delete {family}?',
  'account.deleteFamily.goes': 'For everyone in the family, this removes:',
  'account.deleteFamily.chats':
    'Every chat, with all its photos, videos, voice notes and files.',
  'account.deleteFamily.apps': 'Documents, Links and Lists.',
  'account.deleteFamily.people':
    'Everyone’s stars and the relation names they set here. Everyone leaves the family; their accounts stay.',
  'account.deleteFamily.invites':
    'The family link, and invitations and requests to join that are waiting.',
  'account.deleteFamily.intro': 'It happens at once and can’t be undone.',
  'account.deleteFamily.downloadFirst': 'Download first',
  'account.deleteFamily.continue': 'Confirm it’s you',
  'account.deleteFamily.keep': 'Keep the family',
  'account.deleteFamily.typeTitle': 'Type the family’s name',
  'account.deleteFamily.typeBody':
    'To delete it for everyone, type {family} exactly as it’s shown.',
  'account.deleteFamily.nameLabel': 'Family name',
  'account.deleteFamily.confirm': 'Delete family',
  'account.deleteFamily.done': '{family} was deleted',
  'account.deleteFamily.deletedBy': '{family} was deleted by {name}.',
  'account.deleteFamily.dismiss': 'OK',
  'account.deleteFamily.gone': 'You’re no longer in {family}.',
  'account.exportFamily.size': 'About {size}, {count} files.',
  'account.exportFamily.parts':
    'That’s too big to put together in one go on this device, so it comes as {count} zips of up to 500 MB each. You save them one at a time.',
  'account.exportFamily.doneParts': '{count} files saved in {parts} zips.',
  'account.exportFamily.partSaved': 'Part {part} of {count} saved',
  'account.exportFamily.nextPart':
    'Tap below to put together and save the next part. Keep Twinden open.',
  'account.exportFamily.savePart': 'Save part {part} of {count}',
  // App review access (M56, D203): the review link's landing.
  'account.review.title': 'Twinden review',
  'account.review.signingIn': 'Signing you in to the review family…',
  'account.review.signedInAs':
    'You’re signed in as {name} on this device. Sign out to open the review family?',
  'account.review.switch': 'Sign out and open the review family',
  'account.review.stay': 'Stay signed in',
  'account.review.expired':
    'This review link has expired. Ask the Twinden team for a new one.',
  'account.review.revoked':
    'This review link was turned off. Ask the Twinden team for a new one.',
  'account.review.invalid':
    'This review link isn’t valid. Check that you copied all of it.',
  'account.review.failed':
    'Couldn’t sign in. Check your connection and try again.',
  'account.review.tryAgain': 'Try again',
  'account.review.home': 'Go to Twinden',
  'account.sessions.title': 'Signed-in sessions',
  'account.sessions.description':
    'Every phone, computer and browser that can open Twinden as you. Sign out any you don’t recognise.',
  'account.sessions.thisDevice': 'This device',
  'account.sessions.browserOn': '{browser} on {os}',
  'account.sessions.appFor': 'Twinden for {os}',
  'account.sessions.unknown': 'Unknown device',
  'account.sessions.via.passkey': 'Signed in with a passkey on this device',
  'account.sessions.via.enrolled': 'Signed in when its passkey was made',
  'account.sessions.via.passkeyOther': 'Signed in with the passkey on {name}',
  'account.sessions.via.passkeyOtherUnnamed':
    'Signed in with a passkey on another device',
  'account.sessions.via.qr': 'Signed in by scanning with {name}',
  'account.sessions.via.qrUnnamed': 'Signed in by scanning with your phone',
  'account.sessions.via.review': 'Review session',
  'account.sessions.via.unknown': 'Signed in with a passkey',
  'account.sessions.times': 'First seen {first} · last used {used}',
  'account.sessions.firstSeen': 'First seen {first}',
  'account.sessions.signOut': 'Sign out',
  'account.sessions.signOutNamed': 'Sign out {name}',
  'account.sessions.signOutTitle': 'Sign out “{name}”?',
  'account.sessions.signOutBody':
    'Within a minute it stops opening Twinden as you, and it needs a passkey to sign in again. A passkey on it stays until you remove it under My devices. You’ll confirm it’s you first.',
  'account.sessions.signOutThisTitle': 'Sign out of this device?',
  'account.sessions.signOutThisBody':
    'This device signs out now. Sign in again with your passkey whenever you like.',
  'account.sessions.keep': 'Keep it signed in',
  'account.sessions.everywhereElse': 'Sign out everywhere else',
  'account.sessions.everywhereElseTitle': 'Sign out everywhere else?',
  'account.sessions.everywhereElseBody':
    'Every other phone, computer and browser signs out within a minute. This device stays signed in. Your passkeys stay, so your own devices can sign in again. You’ll confirm it’s you first.',
  'account.sessions.signedOutOne': 'Signed out',
  'account.sessions.signedOutOther': 'Signed out {count} sessions',
  'account.sessions.failed': 'Could not sign it out',
  'account.sessions.loadFailed': 'Could not load your sessions',
  'account.sessions.onlyThis': 'No other device is signed in.',
} as const;
